module.exports = "https://redage.akamaized.net/src/views/player/documets/lspdbadge/images/6.png";